var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input__field", class: { error: _vm.error } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("span", {
        staticClass: "input__message",
        class: { show: _vm.error },
        domProps: { innerHTML: _vm._s(_vm.$t("" + _vm.error)) },
        on: { click: _vm.handleMessageClick }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }